import React, { memo } from "react";
import useDateRangeFilter from "./index.hooks";
import { Button, Divider, Fade, Menu, MenuItem } from "@material-ui/core";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DateFilterTypes } from "redux-store/slices/stats/interfaces";

type DateRangeFilterProps = {};

const DateRangeFilter = ({}: DateRangeFilterProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    anchorRef,
    anchorOrigin,
    transformOrigin,
    dateRangeMenuOpen,
    handleDateRangeMenuOpen,
    handleDateRangeMenuClose,
    dateRangeOptions,
    handleMenuItemClick,
    dateFilterType,
  } = useDateRangeFilter();

  const renderMenuItem = (index, option) => {
    return (
      <MenuItem
        key={index}
        value={option.filter}
        className={styles.listItem}
        onClick={(ev) => {
          handleMenuItemClick(option.filter);
        }}
      >
        {option.desc}
      </MenuItem>
    );
  };

  return (
    <>
      <Button
        ref={anchorRef}
        variant="contained"
        color="secondary"
        className={styles.menuButton}
        startIcon={<DateRangeIcon />}
        endIcon={<ExpandMoreIcon />}
        onClick={handleDateRangeMenuOpen}
      >
        {dateRangeOptions?.find((option) => option.filter === dateFilterType)
          ?.desc ?? "-"}
      </Button>
      <Menu
        id="daterange-menu"
        anchorEl={anchorRef.current}
        getContentAnchorEl={null}
        open={dateRangeMenuOpen}
        onClose={handleDateRangeMenuClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        TransitionComponent={Fade}
        classes={classes.dateRangePaper}
      >
        {dateRangeOptions.map((option, index) => {
          if (option.filter === DateFilterTypes.CUSTOM) {
            return (
              <div>
                <Divider />
                {renderMenuItem(index, option)}
              </div>
            );
          }
          return renderMenuItem(index, option);
        })}
      </Menu>
    </>
  );
};

export default memo(DateRangeFilter);
